const problems = [
  {
    icon: 'ri-phone-missed-line',
    title: 'Missed calls are missed revenue.',
    description:
      'Every unanswered call walks straight to your competitor. Without 24/7 coverage, you lose jobs before they start.',
  },
  {
    icon: 'ri-time-line',
    title: 'Scheduling eats your team alive.',
    description:
      'Hours wasted on back-and-forth booking. Customers expect instant confirmation—manual systems can\'t deliver.',
  },
  {
    icon: 'ri-chat-off-line',
    title: 'Estimates disappear into silence.',
    description:
      'Without structured follow-up, most proposals go cold. The deal was there—your process let it slip.',
  },
  {
    icon: 'ri-arrow-down-circle-line',
    title: 'Leads fall through every day.',
    description:
      'Scattered across calls, texts, and email—qualified prospects vanish without a system to catch them.',
  },
  {
    icon: 'ri-layout-masonry-line',
    title: 'No visibility. No control.',
    description:
      'Teams operating blind. No one knows where a job stands until something goes wrong.',
  },
];

export default function ProblemSection() {
  return (
    <section className="bg-white py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-20">
          <p className="text-[#6E6E73] text-sm font-semibold uppercase tracking-widest mb-5">
            The Problem
          </p>
          <h2 className="text-5xl lg:text-6xl font-extrabold text-[#0A0A0A] leading-none tracking-tighter">
            Why service businesses
            <br />
            <span className="text-[#6E6E73] font-light">bleed revenue daily.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-px bg-[#F5F5F7] rounded-2xl overflow-hidden border border-[#E5E5EA]">
          {problems.map((problem, idx) => (
            <div
              key={problem.title}
              className={`bg-white p-8 group hover:bg-[#F5F5F7] transition-colors ${
                idx === 4 ? 'md:col-span-2 lg:col-span-1' : ''
              }`}
            >
              <div className="w-11 h-11 flex items-center justify-center bg-[#F5F5F7] rounded-xl mb-6 group-hover:bg-white transition-colors">
                <i className={`${problem.icon} text-[#0A0A0A] text-lg`} />
              </div>
              <h3 className="text-[#0A0A0A] font-bold text-base mb-3 leading-snug tracking-tight">
                {problem.title}
              </h3>
              <p className="text-[#6E6E73] text-sm leading-relaxed">
                {problem.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
